<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router'

  defineProps<{
    to?: RouteLocationRaw,
    href?: string,
    disabled?: boolean,
    active: boolean,
  }>()

  const emit = defineEmits<{
    (e: 'click'): void,
  }>()

</script>

<template>
  <div @click="emit('click')">
    <router-link
      v-if="to && !disabled"
      class="dropdown-item"
      :class="{
        '!cursor-not-allowed !text-gray-400 hover:!bg-gray-100': disabled,
        'bg-primary text-white': active,
      }"
      :to="to">
      <slot></slot>
    </router-link>
    <component
      :is="href ? 'a' : 'button'"
      v-else
      class="dropdown-item"
      :class="{
        '!cursor-not-allowed !text-gray-400 hover:!bg-gray-100': disabled,
        'bg-primary-200': active,
      }"
      :target="href ? '_blank' : undefined"
      :href="href"
      :type="href ? undefined : 'button'">
      <slot></slot>
    </component>
  </div>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";

  .dropdown-item {
    @apply w-full flex cursor-pointer items-center whitespace-nowrap px-4 py-2 text-left;

    &:hover,
    &.active {
      @apply bg-primary-200;
    }

    &.disabled {
      @apply !cursor-not-allowed !text-gray-400 hover:!bg-gray-100;
    }
  }
</style>
